import { LineChartDataPoint } from '@modules/charts/types';

const DOT_RADIUS = 3;
const DOT_RADIUS_LG = 5;
const STROKE_WIDTH = 2;
const STROKE_WIDTH_SM = 1;

interface LineChartDotProps {
  cx?: number;
  cy?: number;
  fill?: string;
  anomalyFill: string;
  dataPointsCount: number;
  isIncompleteLine: boolean;
  dataKey?: string;
  name?: string;
  value?: number;
  stroke?: string;
  strokeDasharray?: string;
  payload?: LineChartDataPoint;
  index?: number;
  handleMouseEnter?: (
    eve: React.MouseEvent<unknown, MouseEvent>,
    dataKey: string | undefined,
    value: number | undefined,
    payload: LineChartDataPoint | undefined,
  ) => void;
  handleMouseLeave?: () => void;
  isOnHoverVariant?: boolean;
}

export const LineChartDot = (props: LineChartDotProps) => {
  const {
    cx,
    cy,
    fill,
    anomalyFill,
    stroke,
    strokeDasharray,
    payload,
    value,
    isOnHoverVariant,
    handleMouseEnter,
    handleMouseLeave,
    index,
    dataPointsCount,
    isIncompleteLine,
    name = '',
  } = props;

  const isAnomalousDot =
    typeof payload?.[name] === 'object'
      ? !!payload?.[name]?.anomalyValue
      : false;

  const shouldShowLargeDot = isOnHoverVariant || isAnomalousDot;
  const radius = shouldShowLargeDot ? DOT_RADIUS_LG : DOT_RADIUS;
  const fillColor = isAnomalousDot ? anomalyFill : fill;
  const strokeColor = isOnHoverVariant ? fill : stroke;

  const isIncompleteLineDot =
    isIncompleteLine && index !== dataPointsCount - 1 && index !== 0;

  if (!cx || !cy || isIncompleteLineDot) {
    return null;
  }

  return (
    <circle
      r={radius}
      cx={cx}
      cy={cy}
      radius={radius}
      fill={fillColor}
      stroke={isOnHoverVariant && !isAnomalousDot ? 'none' : strokeColor}
      strokeWidth={isOnHoverVariant ? STROKE_WIDTH_SM : STROKE_WIDTH}
      strokeDasharray={strokeDasharray}
      onMouseEnter={(eve) => {
        handleMouseEnter?.(eve, name, value, payload);
      }}
      onMouseLeave={handleMouseLeave}
    />
  );
};
